import React , { useState, useEffect } from 'react';
import axios from 'axios';
import { Input, Button, message } from 'antd';
import { UserOutlined, PhoneOutlined, KeyOutlined } from '@ant-design/icons';
import './loginBox.scss';
import queryString from "query-string";
import { Link, Redirect } from 'react-router-dom';
import RSA from '@supervision/common/rsa';
import SlidingModal from '@rootComponents/slidingValidation';
import Axios from 'axios';


function LoginIndex(props) {
  const [companyName, setCompanyName] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [loginState, setLoginState] = useState(false);
  const [waitTime, setWaitTime] = useState(60);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [isClickYZM, setIsClickYZM] = useState(false);
  const [config, setConfig] = useState({});
  const [captchaModal, setCaptchaModal] = useState(false);

  // 获取配置
  const getMyConfig = () => {
    axios({
      method: 'post',
      url:"/user-center/servlet/facade.script?action=getLoginInfo",
      transformResponse: [function (data) {
        return JSON.parse(data.split('=')[1])
      }],
    })
      .then(function (response) {
        setConfig(response.data)
      })
  }

  useEffect(() => {
    getMyConfig()
    /**
     * 访问渠道
     * form => 0:官网首页 1:正式登录 2:游客登录 3:注册页 4:服务费用
     * source => 0:小程序 1:web端 2:h5端
    */
    Axios({url:'/user-center/accountVisit/addVisit.ajax?form=2&source=1'})
  }, []);
  

  const openCaptchaClock = () => {
    let num = 59;
    let clock = setInterval(() => {
      setWaitTime(num --);

      if (num === 0) {
        setWaitTime(60);
        setCaptchaLoading(false);
        clearInterval(clock);
      }
    }, 1000);
  }

  const userLogin = () => {
    if (!companyName) return message.error('企业名称不可为空');
    // if (!checkCompanyName()) return message.error('企业全称只可以为汉字字符，英文字符，数字，中文括号组成');
    // if (!checkCompanyName()) return message.error('企业全称不能为空');
    // if (!checkPhoneNumber()) return message.error('手机号格式不正确!');
    if (!checkPhoneNumber()) return message.error('手机号格式不正确!');
    if (!captcha.length) return message.error('验证码不可为空!');
    if (!captcha) return message.error('验证码错误!');

    // 判断当前公司名是否存在
    axios({
      method: 'post',
      url:"/user-center/account/checkCompayName.ajax",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}, // application/x-www-form-urlencoded
      data:  queryString.stringify({ companyName:companyName.trim() })
       // 除去前后空格
    }).then((res) => {
      if (res.data) throw '该企业已注册！';

      // 如果公司不存在，执行判断验证码是否正确的操作
      checkYZM();
    })
    .catch((res) => {
      message.error(res);
    })

  }

  const checkYZM = () => {
    axios({
      method: 'post',
      url:"/user-center/phone/checkYzm.ajax",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}, // application/x-www-form-urlencoded
      data:  queryString.stringify({ msisdn: Number(userPhone), yzm: captcha })
    }).then((res) => {
       // 失败则提示
      if (res.data.code === 200) {
          if (!res.data.data) return message.error(res.message || '验证码错误！');
          
          // 成功 跳转至收信箱页面
          sessionStorage.setItem("companyName", companyName);
          sessionStorage.setItem("userPhone", userPhone);
          setLoginState(true);
      }
      if (res.data.code === 500) {
        return message.error(res.data.msg);
      }
    })
  }
  
  const send = () => {
    if (!checkPhoneNumber()) return message.error('请输入正确的手机号码');
    if (captchaLoading) return; // 如果正在等待倒计时则不往下走
    
    // 判断当前手机号码是否注册
    axios({
      method: 'POST',
      url:"/user-center/account/checkAccountNo.ajax",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}, // application/x-www-form-urlencoded
      data: queryString.stringify({tel: Number(userPhone)})
    }).then((res) => {
      if (res.data.status === 0) throw '该手机号已注册!';
    })
    .then(() => {
      // 如果未注册 发送验证码
      setCaptchaModal(true)
      // sendYZM();
    }).catch((res) => {
      message.error(res);
    })
  }

  const sendYZM = (params, callback) => {
    if (!checkPhoneNumber()) return message.error('请输入正确的手机号码');
    var _GLOBAL = config || {};
    var rsa = new RSA.RSAKey();
    rsa.setPublic(_GLOBAL['modulus'], _GLOBAL['exponent']);
    var passPhoneNum = rsa.encrypt(userPhone);
    axios({
      method: 'POST',
      url:"/user-center/phone/sendToUser.ajax",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}, // application/x-www-form-urlencoded
      data: queryString.stringify({...params, msisdn: passPhoneNum, type: "yanzhengma"})
    }).then((res) => {
      callback(res.data)
      if (res.data.code === 200) {
        if (res.data.data) {
          // 定时器 倒计时60s 逻辑
          setCaptchaLoading(true);
          setIsClickYZM(true);
          openCaptchaClock();
        } else {
          message.error('发送失败！');
        }
      }
    })
  }

  const checkCompanyName = () => {
    // todo 企业名称非空的需求
    return /\s+/g.test(companyName)
    // return /^[\u4e00-\u9fa5a-zA-Z\d\(\)（）()\-\.]+$/.test(companyName);
  }

  const checkPhoneNumber = () => {
    return /^1[3|4|5|8][0-9]\d{8}$/.test(userPhone);
  }

  const companyNameChange = (e) => {
    e.persist();
    setCompanyName(e.target.value);
  }
  
  const userPhoneChange = (e) => {
    e.persist();
    setUserPhone(e.target.value);
  }

  const captchaChange = (e) => {
    e.persist();
    setCaptcha(e.target.value);
  }

  const goRegister = () => {
    window.location.href = 'https://www.001pt.com/login/register.html';
  }

  if (loginState) return (
    <Redirect to = '/visitHome' />
  )

  return (
    <div className="login-box">
      <div className="enterprise">
        <Input 
          prefix={<UserOutlined />}
          placeholder="企业名称" 
          maxLength="60"
          onChange={(e) => companyNameChange(e)}
        />
      </div>
      <div className="phone">
        <Input
          prefix={<PhoneOutlined/>}
          placeholder="手机号" 
          maxLength="11"
          onChange={(e) => userPhoneChange(e)}
        />
      </div>
      <div className="code">
        <Input 
          prefix={<KeyOutlined/>}
          placeholder="动态码" 
          onChange={(e) => captchaChange(e)}
        />
        <span className="get-code" onClick={send}>
          {
            captchaLoading ? 
            <span>请稍候（{waitTime}）</span> : 
            isClickYZM ?
            <span>重新获取验证码</span> :
            <span>获取验证码</span>
          }
        </span>
      </div>
      <Button type="primary" htmlType="submit" onClick={userLogin}>
        登录
      </Button>
      <div className="register-btn">
        <span onClick={goRegister}>新用户注册</span>
      </div>
      {
        captchaModal ? <SlidingModal 
          msisdn={userPhone}
          handleCancel={
            ()=>setCaptchaModal(false)
          }
          sendCaptcha={(params, callback)=>{
            sendYZM(params, callback)
          }}
        ></SlidingModal> : ""
      }
    </div>
  )
}

export default LoginIndex;
